<template>
    <div>

        <!--<ddoAlert :errors="level.errors"/>-->

        <v-card-title v-if="level.dialogValues.form_create">
         <slot name="title_create" v-scope="props">
            <span class="headline">{{ level.dialogValues.headers.create }}</span>
         </slot>
        </v-card-title>
        <!-- 2019-11-11, SDO : BUG : We need a :hint="row._pk" to obtain a real refresh of "values.header_value"-->
        <v-card-title v-if="level.dialogValues.form_update && !level.dialogValues.readonly" :hint="row._pk">
         <slot name="title_update" v-scope="props">
            <span class="headline">{{ level.dialogValues.headers.update }} "{{ level.dialogValues.header_value }}"</span>
         </slot>
        </v-card-title>
        <v-card-title v-if="level.dialogValues.form_update && level.dialogValues.readonly" :hint="row._pk">
         <slot name="title_delete" v-scope="props">
            <span class="headline">{{ level.dialogValues.headers.select }} "{{ level.dialogValues.header_value }}"</span>
         </slot>
        </v-card-title>
        <!-- 2019-11-11, SDO : BUG : We need a :hint="row._pk" to obtain a real refresh of "values.header_value"-->
        <v-card-title v-if="level.dialogValues.form_delete && !level.dialogValues.readonly" :hint="row._pk">
          <span class="headline">{{ level.dialogValues.headers.delete }} "{{ level.dialogValues.header_value }}"</span>
        </v-card-title>

        <!-- 2019-12-27, SDO : v-card-subtitle seems to exist, but is not loaded/registered. So, we use v-card-text instead... -->
        <v-card-text>
          <slot name="subheader">
          </slot>
        </v-card-text>

    </div>
</template>

<script>
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';

export default {
    name: 'CardUpdatableHeader',
    components: {
        ddoAlert,
        CardUpdatable
    },
    extends: CardUpdatable,
    data: function () {
        return {
        };
    },
}
</script>